import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { kebabCase } from "lodash";
import { endOfMonth, startOfMonth } from "date-fns";

import { Loader } from "@hydra/atom/components";
import { JobBoard } from "@/components/facility/board";
import {
  Header,
  CustomizedDateRangePicker,
  SvgIcon,
  IconButton,
  NoDataFound,
  HeaderLeftContent
} from "@/components/common";
import { formatApiPayloadDate } from "@/utils/helpers";
import { getDynamicObjectRecords } from "@/api/dynamic/dynamicObjectNameApi";
import dynamicObjectMap from "@/utils/maps/dynamicObjectMap";

function WorkOrderBoardView() {
  const [dateRange, setDateRange] = useState([startOfMonth(new Date()), endOfMonth(new Date())]);
  const { data: jobs, isInitialLoading } = useQuery(
    [
      kebabCase(dynamicObjectMap.get("WorkOrderJobObjectName")),
      {
        sortBy: "CreatedAt",
        sortType: "DESC",
        queryMode: "Deep",
        dateRange
      },
    ],
    () =>
      getDynamicObjectRecords(dynamicObjectMap.get("WorkOrderJobObjectName"), {
        sortBy: "CreatedAt",
        sortType: "DESC",
        queryMode: "Deep",
        "startDate[gte]": formatApiPayloadDate(dateRange[0]),
        "endDate[lte]": formatApiPayloadDate(dateRange[1]),
      })
  );

  if (isInitialLoading) return <Loader />;

  const noJobs = !jobs || !jobs?.data?.length;

  return (
    <div className="job-board-container">
      <Header
        className="mt-15"
        leftContent={(
          <div className="board-left-content">
            <HeaderLeftContent
              title="Work orders Board"
              subtitle="Supercharge your workflow and connect the tool you use every day."
            />
          </div>
        )}
        rightContent={(
          <div className="work-order-right-content ">
            <CustomizedDateRangePicker name="dateRange" value={dateRange} onChange={setDateRange} required />
            <IconButton onClick={() => {}}>
              <SvgIcon icon="more" />
            </IconButton>
          </div>
        )}
      />
      {noJobs ? <NoDataFound title="No job has been found" /> : <JobBoard jobs={jobs} />}
    </div>
  );
}

export default WorkOrderBoardView;
